import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast,
} from "@chakra-ui/react"
import { useRef } from "react"
import { useMutation, useQueryClient } from "react-query"
import { baseURL } from "../../../services/api"

export function ConfirmePagamento({ numero_unico }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  const toast = useToast({
    position: "top",
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation(
    async (data) => {
      const response = await baseURL.get(`/pedido/atualiza-pedido-pago/${data}`)
      return response.data
    },
    {
      onSuccess: () => {
        toast({
          title: "Sucesso",
          description: "Baixa realizada com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        })

        queryClient.invalidateQueries("data-client")
      },
    },
  )

  async function onSubmit() {
    await mutateAsync(numero_unico)
    onClose()
  }

  return (
    <>
      <Button colorScheme="blue" onClick={onOpen}>
        Dar baixa
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Você tem certeza?
            </AlertDialogHeader>

            <AlertDialogBody>Você não poderá desfazer essa ação posteriormente.</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="blue" onClick={onSubmit} ml={3} isLoading={isLoading}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
